


export enum CreditoInicial{
  Valor = 5
}
